import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  AiOutlineSafetyCertificate,
  AiOutlineQuestionCircle,
} from 'react-icons/ai';
import { BsChatLeft } from 'react-icons/bs';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import { verifyUser } from 'utils/functions';
import { FAQOPTIONS } from './enuns';

import {
  Container,
  TitleHome,
  SubTitleHome,
  HomeContainer,
  BoxIconContainer,
  BoxLinkContainer,
  BoxTextContainer,
  BoxSeparator,
  ButtonBack,
} from './styles';
import Faq from './Faq';

function Contato(props) {
  const history = useHistory();
  const location = useLocation();

  const [faqPages, setFaqPages] = useState(FAQOPTIONS.home);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    if (location.state?.view === FAQOPTIONS.faq) {
      setFaqPages(FAQOPTIONS.faq);
    }
  }, [location.state]);

  useEffect(() => {
    if (!showTour) return;
    setTourType('fale-conosco');
    setSteps(3);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    async function getAccessToken() {
      const token = await localStorage.getItem(
        '@UltragazEmpresarial:accessToken'
      );

      if (!token) {
        verifyUser(props);
      }
    }

    getAccessToken();
  }, [props]);

  function handleChangeView(view) {
    setFaqPages(view);
  }

  function handleClickOpenChat() {
    const chatbotButton = document?.querySelector('#hi-custom-widget');
    if (chatbotButton) {
      chatbotButton.click();
    }
  }

  return (
    <Navbar
      selected={faqPages === FAQOPTIONS.faq ? 'duvidas-frequentes' : 'contato'}
      openSubMenu="contato"
    >
      <UserMenu breadcrump="› FAQ" />

      {faqPages === FAQOPTIONS.home && (
        <Container>
          <TitleHome>Olá! Como podemos lhe ajudar?</TitleHome>
          <SubTitleHome>
            Selecione a melhor opção para lhe atendermos
          </SubTitleHome>
          <TableWrap
            showTour={showTour && tourType === 'fale-conosco' && tourStep === 3}
          >
            <HomeContainer>
              <BoxLinkContainer
                onClick={() => handleChangeView(FAQOPTIONS.faq)}
              >
                <BoxIconContainer>
                  <AiOutlineQuestionCircle size={48} color="#000eff" />
                </BoxIconContainer>
                <BoxSeparator />
                <BoxTextContainer>Dúvidas</BoxTextContainer>
                <BoxTextContainer>frequentes</BoxTextContainer>
              </BoxLinkContainer>
              <BoxLinkContainer onClick={() => handleClickOpenChat()}>
                <BoxIconContainer>
                  <BsChatLeft size={48} color="#000eff" />
                </BoxIconContainer>
                <BoxSeparator />
                <BoxTextContainer>Falar</BoxTextContainer>
                <BoxTextContainer>via chat</BoxTextContainer>
              </BoxLinkContainer>
              <BoxLinkContainer
                onClick={() => history.push('/dicas-seguranca')}
              >
                <BoxIconContainer>
                  <AiOutlineSafetyCertificate size={48} color="#000eff" />
                </BoxIconContainer>
                <BoxSeparator />
                <BoxTextContainer>Dicas de</BoxTextContainer>
                <BoxTextContainer>segurança</BoxTextContainer>
              </BoxLinkContainer>
            </HomeContainer>
            {showTour && tourType === 'fale-conosco' && tourStep === 3 && (
              <TourBalloon
                title="Fale Conosco"
                content="Aqui você pode selecionar as dúvidas frequentes, ou acionar a Ully para sanar suas dúvidas."
                position={{
                  left: '0',
                  right: '0',
                  top: '96%',
                  arrowPosition: 'top',
                  maxWidth: null,
                  boxShadow: false,
                }}
              />
            )}
          </TableWrap>
        </Container>
      )}

      {faqPages === FAQOPTIONS.faq && (
        <Container>
          <div
            className="intro-contato"
            style={{
              paddingBottom: '64px',
            }}
          >
            <div
              style={{
                margin: '24px 0',
              }}
            >
              <TitleHome>Dúvidas frequentes</TitleHome>
              <SubTitleHome>
                Selecione a que faz mais sentido para você!
              </SubTitleHome>
            </div>
            <Faq />
            <ButtonBack onClick={() => handleChangeView(FAQOPTIONS.home)}>
              Voltar
            </ButtonBack>
          </div>
        </Container>
      )}
    </Navbar>
  );
}

export default Contato;
